/*! @pentacode/ui v0.1.0 */
import { formatCurrency as e, formatDay as t } from "../format.js";
import { n, t as r } from "../../theme-BDdgxk0M.js";
import { t as i } from "../../line-BNF2PSKe.js";
// src/charts/presets/savings.ts
var a = {
	Ersparnis: r.positive,
	Gebühren: n[7]
};
function o(e) {
	return Math.round(e * 100) / 100 + 0;
}
function s(e, t) {
	let n = [];
	for (let { date: t, savings: r } of e) {
		if (r === void 0) break;
		n.push({
			x: t,
			series: "Ersparnis",
			value: o((n.at(-1)?.value ?? 0) + r)
		});
	}
	return {
		savings: n,
		fees: e.map(({ date: e }) => ({
			x: e,
			series: "Gebühren",
			value: t
		})),
		breakEvenDate: t > 0 ? n.find((e) => e.value >= t)?.x : void 0
	};
}
function c(n, o, c = {}) {
	let { savings: l, fees: u, breakEvenDate: d } = s(n, o);
	return i([...l, ...u], {
		...c,
		area: ["Ersparnis"],
		grouped: !0,
		threshold: {
			value: o,
			below: r.negative,
			above: r.positive
		},
		format: e,
		colors: a,
		markers: d ? [{
			x: d,
			label: `Break-even: ${t(d)}`
		}] : []
	});
}
export { s as cumulativeSavings, c as savingsChart, a as savingsColors };

//# sourceMappingURL=savings.js.map